
import React, { useContext } from 'react';
import { TimerContext } from '../contexts/TimerContext';
import { Button, Typography, Paper, Box, Chip } from '@mui/material';
import { PlayArrow, Pause, Stop, PlayCircleOutline } from '@mui/icons-material';

const Timer = () => {
  const {
    time,
    isActive,
    isPaused,
    startTimer,
    stopTimer,
    pauseTimer,
    resumeTimer,
  } = useContext(TimerContext);

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        Timer
      </Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography 
          variant="h1" 
          component="div"
          sx={{ 
            fontFamily: 'monospace',
            fontSize: { xs: '2.5rem', sm: '4rem' },
            fontWeight: 'bold',
            color: isActive && !isPaused ? 'primary.main' : 'text.primary'
          }}
        >
          {formatTime(time)}
        </Typography>
        
        {isActive && (
          <Chip 
            label={isPaused ? 'Paused' : 'Running'} 
            color={isPaused ? 'warning' : 'success'} 
            variant="outlined"
            sx={{ mt: 1 }}
          />
        )}
      </Box>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        {!isActive && !isPaused ? (
          <Button 
            onClick={startTimer} 
            variant="contained" 
            color="primary"
            size="large"
            startIcon={<PlayArrow />}
            sx={{ minWidth: 120 }}
          >
            Start
          </Button>
        ) : (
          <>
            {isPaused ? (
              <Button 
                onClick={resumeTimer} 
                variant="contained" 
                color="primary"
                size="large"
                startIcon={<PlayCircleOutline />}
                sx={{ minWidth: 120 }}
              >
                Resume
              </Button>
            ) : (
              <Button 
                onClick={pauseTimer} 
                variant="contained" 
                color="warning"
                size="large"
                startIcon={<Pause />}
                sx={{ minWidth: 120 }}
              >
                Pause
              </Button>
            )}
            <Button 
              onClick={stopTimer} 
              variant="contained" 
              color="error"
              size="large"
              startIcon={<Stop />}
              sx={{ minWidth: 120 }}
            >
              Stop
            </Button>
          </>
        )}
      </Box>
    </Paper>
  );
};

export default Timer;
